const routes = [
  {
    path: '/members',
    component: () => import('./1index.vue'),
  },
];

export default routes;
